import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import useHelpers from 'hooks/helpers';

const ITEMS_PER_PAGE_FALLBACK = 20;

export const useArticlePagination = (resetTrigger?: unknown) => {
  const router = useRouter();
  const { page } = router.query;
  const { updateUrlParams } = useHelpers();
  const { take } = updateUrlParams();
  const [currentPage, setCurrentPage] = useState(Number(page ?? 1));
  const [itemsPerPage, setItemsPerPage] = useState<number>();

  useEffect(() => {
    setItemsPerPage(Number(take || ITEMS_PER_PAGE_FALLBACK));
  }, [take]);

  useEffect(() => {
    if (page) {
      setCurrentPage(Number(page));
    }
  }, [page]);

  useEffect(() => {
    if (resetTrigger !== undefined) {
      setCurrentPage(1);
      updateUrlParams([
        {
          name: 'page',
          value: '',
        },
      ]);
    }
    // Adding `updateUrlParams` results in unwanted reset.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resetTrigger]);

  const handlePageNumberChange = (selectedPage: number) => {
    setCurrentPage(selectedPage);
    updateUrlParams([
      {
        name: 'page',
        value: selectedPage === 1 ? '' : selectedPage,
      },
    ]);
  };

  const handlePageSizeChange = (value: number) => {
    setCurrentPage(1);
    setItemsPerPage(value);
    updateUrlParams([
      {
        name: 'take',
        value: value === 20 ? '' : value,
      },
      {
        name: 'page',
        value: '',
      },
    ]);
  };

  return {
    currentPage,
    itemsPerPage: itemsPerPage ?? ITEMS_PER_PAGE_FALLBACK,
    handlePageNumberChange,
    handlePageSizeChange,
  };
};
